export default {
  quick_links: {
    title: 'Linkuri rapide',
    developers: 'Dezvoltatori',
    agencies: 'Agenții',
    properties: 'Proprietăți',
  },
  company: {
    title: 'Despre companie',
    about_services: 'Despre serviciu',
    news: 'Știri',
    statistic: 'Statistici',
  },
  support: {
    title: 'Asistență',
  },
  get_in_touch: 'Contactați-ne',
  email: 'info(at)estimator24.com',
  phone: '+41762378017',
  copyright: 'Estimator24.com'
}
